import { render, staticRenderFns } from "./TakeoffPassengersDataPage.vue?vue&type=template&id=e4ab9da8&scoped=true&"
import script from "./TakeoffPassengersDataPage.vue?vue&type=script&lang=js&"
export * from "./TakeoffPassengersDataPage.vue?vue&type=script&lang=js&"
import style0 from "./TakeoffPassengersDataPage.vue?vue&type=style&index=0&id=e4ab9da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ab9da8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4ab9da8')) {
      api.createRecord('e4ab9da8', component.options)
    } else {
      api.reload('e4ab9da8', component.options)
    }
    module.hot.accept("./TakeoffPassengersDataPage.vue?vue&type=template&id=e4ab9da8&scoped=true&", function () {
      api.rerender('e4ab9da8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/data/takeoffPassengersData/TakeoffPassengersDataPage.vue"
export default component.exports